import { render } from "./MembersPage.vue?vue&type=template&id=1c10158b&scoped=true"
import script from "./MembersPage.vue?vue&type=script&lang=js"
export * from "./MembersPage.vue?vue&type=script&lang=js"

import "./MembersPage.vue?vue&type=style&index=0&id=1c10158b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c10158b"]])

export default __exports__